import React from 'react'
import { useSelector } from 'react-redux';
import storePersist from '../../../../../redux/storePersist';
import { selectListItems } from '../../../../../redux/library/selector';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';

export default function GatewayBasicInfoComponent({ dbas, handleFormChange, selectedGateway, handleInnerFormChange, domainDetails, networks }: any) {
  const countries = storePersist.get('countries').current?.items;
  const libraryData = useSelector(selectListItems)
  const Cities = [
    { Id: 1, Name: "Bangalore", StdCode: "std:080",  StateCode: 105, CountryCode: 133  },
    { Id: 2, Name: "Chennai", StdCode: "std:044",  StateCode: 105, CountryCode: 133 },
    { Id: 3, Name: "Coimbatore", StdCode: "std:0422",  StateCode: 105, CountryCode: 133 },
    { Id: 4, Name: "Madurai", StdCode: "std:0452",  StateCode: 105, CountryCode: 133 },
    { Id: 5, Name: "Salem", StdCode: "std:0427", StateCode: 105, CountryCode: 133  },
    { Id: 6, Name: "Tirupur", StdCode: "std:0421",  StateCode: 105, CountryCode: 133},
    { Id: 7, Name: "Erode", StdCode: "std:0424", StateCode: 105, CountryCode: 133  },
    { Id: 8, Name: "Trichy", StdCode: "std:0431", StateCode: 105, CountryCode: 133  },
    { Id: 9, Name: "Virudhunagar", StdCode: "std:04562", StateCode: 105, CountryCode: 133  },
    { Id: 10, Name: "Trichur", StdCode: "std:0487", StateCode: 93, CountryCode: 133  },
  ]
  return (
    <>
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer
              label="Name"
              name="Name"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Name',

                )
              }}
              type="text"
              value={selectedGateway?.Name}
            />
            <InputContainer
              label="UniqueId"
              name="UniqueId"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'UniqueId',

                )
              }}
              type="text"
              value={selectedGateway?.UniqueId}
            />
            <InputContainer
              isDisabled
              label="DBA Name"
              labelField="Name"
              list={dbas}
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'DBAId',
                );
              }}
              optionName='Choose DBA'
              type="select"
              value={selectedGateway?.DBAId}
              valueField="Id"
            />
            <InputContainer
              label="Subscriber Id"
              name="SubscriberId"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'SubscriberId',

                )
              }}
              type="text"
              value={selectedGateway?.SubscriberId}
            />
            <InputContainer
              label="Subscriber Url"
              name="SubscriberUrl"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'SubscriberUrl',

                )
              }}
              type="text"
              value={selectedGateway?.SubscriberUrl}
            />
            <InputContainer
              label="Status"
              name="Status"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Status',

                )
              }}
              type="text"
              value={selectedGateway?.Status}
            />
            <InputContainer
            isDisabled
              label="Type"
              labelField="Type"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Type'
                )
              }}
              type="text"
              value={selectedGateway?.Type}

            />
            <InputContainer
              label="Domain Name"
              labelField="Name"
              list={domainDetails}
              onValueChange={(newValue: any) => {
                const valueData: any = newValue.map((option: any) => option?.value || '',)
                console.log('valueData', valueData)
                handleInnerFormChange(
                  valueData,
                  'Domains'
                )
              }}
              type="multiselect"
              valueField="Id"
              value={selectedGateway?.Domains}
            />
            <InputContainer
              label="Network Name"
              labelField="Name"
              list={networks}
              onValueChange={(newValue: any) => {
                const valueData: any = newValue.map((option: any) => option?.value)
                handleInnerFormChange(
                  valueData,
                  'Networks',
                )
              }}
              type="multiselect"
              valueField="Id"
              value={selectedGateway?.Networks}
            />
            <InputContainer
              label="Country Name"
              labelField="Name"
              list={countries}
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Country',
                );
              }}
              optionName='Choose Country'
              type="select"
              value={selectedGateway?.Country}
              valueField="Name"
            />

            <InputContainer
              label="Is Limited to Cities"
              name="IsLimitedToCities"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event,
                  'IsLimitedToCities'
                );
              }}
              type="checkbox"
              value={selectedGateway?.IsLimitedToCities}
            />

            {selectedGateway?.IsLimitedToCities ? 
            <InputContainer
              label="Cities"
              labelField="Name"
              list={Cities}
              onValueChange={(newValue: any) => {
                const valueData: any = newValue.map((option: any) => option?.value)
                handleInnerFormChange(
                  valueData,
                  'Cities',
                )
              }}
              type="multiselect"
              valueField="Name"
              value={selectedGateway?.Cities}
            />:<></>}
          </div>
        }
        expandedPanel="userInfo"
        headerTitle="Basic Info"
      />

    </>
  )
}